<template>
    <ejs-grid
        ref="grdTableList"
        :dataSource="items"
        :recordClick="recordOnClick"
        :recordDoubleClick="recordOnDoubleClick"
        :commandClick="actionOnClick"
        :allowSorting="true"
        :allowResizing="true"
        :sortSettings="sortBy"
        :dataStateChange="dataStateChange"
        class="dm-flex-1 dm-overflow-hidden"
        :allowTextWrap="false"
        :textWrapSettings="{ wrapMode: 'Header' }"
        :toolbar="toolbar"
        :headerCellInfo="renderSortingIcon"
        :allowExcelExport="true"
        :allowPdfExport="true"
        :toolbarClick="toolbarClick"
        :allowPaging="allowPaging"
        :pageSettings="pageSettings"
		:enableVirtualization="enableRowVirtualization"
		:enableColumnVirtualization="enableColumnVirtualization"
		:actionComplete="actionComplete"
        :rowDataBound="rowDataBound"
        height="100%">
        <e-columns>
            <e-column
				:key="field.key"
                v-for="field in iconTemplateColumns"
                :field="field.key"
                :headerText="field.label"
                :allowSorting="field.allowSorting"
                :allowResizing=false
                :template="getIconTemplate(field)"
                :width="field.width"
				:minWidth="field.minWidth"
                :customAttributes="field.classes"
                :format="field.format"
                :textAlign="field.textAlign"
				:headerTextAlign="field.headerTextAlign">
            </e-column>
            <e-column
				:key="field.key"
                v-for="field in dataColumns"
                :field="field.key"
                :headerText="field.label"
                :type="field.type"
                :allowSorting="field.allowSorting"
                :commands="field.commands"
                :width="field.width"
				:minWidth="field.minWidth"
                :customAttributes="field.classes"
                :format="field.format"
                :formatter="field.formatter"
                :clipMode="field.clipMode"
                :disableHtmlEncode="false"
                :textAlign="field.textAlign"
				:headerTextAlign="field.headerTextAlign">
            </e-column>
            <e-column
				:key="field.key"
                v-for="field in templateColumns"
                :field="field.key"
                :template="field.template"
                :width="field.width"
				:minWidth="field.minWidth"
                :customAttributes="field.classes"
                :format="field.format"
                :textAlign="field.textAlign"
				:headerTextAlign="field.headerTextAlign"
                :headerText="field.label"
                :clipMode="field.clipMode">
            </e-column>
        </e-columns>
        <e-aggregates>
            <e-aggregate>
                <e-columns>
                    <e-column
						:key="field.key"
                        v-for="field in aggregateColumns"
                        :columnName="field.key"
                        type="Custom"
                        :customAggregate="field.aggregateColumn.doAggregation"
                        :footerTemplate="footerTemplate"
                        :customAttributes="aggregateClasses">
                    </e-column>
                </e-columns>
            </e-aggregate>
        </e-aggregates>
    </ejs-grid>

</template>

<script>
    import Vue from 'vue';
    import { Sort, CommandColumn, Aggregate, PdfExport, ExcelExport, Group, Toolbar, VirtualScroll, Page, Resize } from "@syncfusion/ej2-vue-grids";

    export default {
        name: 'app-table',
        props: ['props', 'columns', 'items', 'rowOnClick', 'actionOnClick', 'sortBy', 'customClass', 'toolbar', 'enableRowVirtualization', 'enableColumnVirtualization', 'actionComplete', 'rowOnDoubleClick', 'allowPaging', 'pageSettings', 'dataStateChange', 'clipMode', 'allowSorting', 'iconTemplate', 'rowDataBound'],
        provide: {
            grid: [
                Sort,
                CommandColumn,
                Aggregate,
                PdfExport,
                ExcelExport,
                Group,
                Toolbar,
				VirtualScroll,
                Page,
                Resize
            ]
        },
        data() {
            return {
                footerTemplate(args) {
                    return {
                        template: Vue.component('footerTemplate', {
                            template: `<span class="dm-text-right">{{data.Custom}}</span>`,
                            data() {
                                return {
                                    data: {},
                                };
                            }
                        })
                    }
                },
                aggregateClasses: {
                    class: 'dm-text-right'
                },
            }
        },
		computed: {
			iconTemplateColumns() {
				return this.columns.filter((col) => {
					return col.type === 'iconTemplate';
				})
			},
			templateColumns() {
				return this.columns.filter((col) => {
					return col.type === 'template';
				})
			},
			aggregateColumns() {
				return this.columns.filter((col) => {
					return col.aggregate;
				})
			},
			dataColumns() {
				return this.columns.filter((col) => {
					return col.type !== 'template' && col.type !== 'iconTemplate';
				})
			}
		},
        methods: {
            getIconTemplate(column) {
                if (column.iconName === 'ellipsis') {
                    return this.getEllipsisTemplate(column.ellipsisActions, column.iconOnClick).template;
                }
                if (column.iconName === 'edit') {
                    return this.getEditTemplate().template;
                }

                return this.iconTemplate[column.name];
            },
            getEllipsisTemplate(ellipsisActions, iconOnClick) {
                return {
                    template: () => {
                        return {
                            template: Vue.component('columnTemplate', {
                                template: `<ejs-dropdownbutton
                                                :items="iconActions"
                                                :select="select"
                                                iconCss="e-icons e-ellipsis-vert"
                                                cssClass= "e-caret-hide">
                                            </ejs-dropdownbutton>`,
                                data() {
                                    return {
                                        iconActions: ellipsisActions
                                    }
                                },
                                methods: {
                                    select(args) {
                                        iconOnClick(args);
                                    }
                                },
                            })
                        }
                    }
                }
            },
            getEditTemplate() {
                return {
                    template: () => {
                        return {
                            template: Vue.component('columnTemplate', {
                                template: `<div class="dm-pointer">
                                                <i class="fa fa-pencil" aria-hidden="true"></i>
                                            </div>`,
                                data() {
                                    return {}
                                },
                            })
                        }
                    }
                }
            },
            recordOnClick(data) {
                if (!data.column || !data.column.commands || data.column.commands.length === 0) {
                    this.rowOnClick(data);
                }
            },
            recordOnDoubleClick(data) {
                this.rowOnDoubleClick(data);
            },
            toolbarClick(args) {
                switch (args.item.text) {
                    case 'PDF Export':
                        this.$refs.grdTableList.pdfExport();
                        break;
                    case 'Excel Export':
                        this.$refs.grdTableList.excelExport();
                        break;
                    case 'CSV Export':
                        this.$refs.grdTableList.csvExport();
                        break;
                }
            },
            renderSortingIcon(args) {
                if (args.cell.column.allowSorting) {
                    args.node.classList.add('customicon');
                }
            },
        },
    }
</script>